module.exports = __webpack_public_path__ + "img/dash-certificate.78543ec9.svg";